<template>
  <div class="sidebar-nav-stores-and-events row">
    <SidebarNavItem :item="storeEvents" />
    <SidebarNavItem
      v-if="beautyClasses.length !== 0"
      :item="beautyClass"
    />
    <div
      v-if="isSortedByState == false"
      :item="isSortedByState"
    >
      <SidebarNavItem :item="storeLocations">
        <template v-slot:default="slotProps">
          <ul class="links">
            <li
              v-for="city in slotProps.item.children"
              :key="city.slug"
              class="cities"
            >
              <router-link
                class="city"
                :class="{ 'display-city': slotProps.item.children.length > 1 }"
                :to="{ name: city.path, hash: city.hash }"
                v-text="city.name"
              />
              <template v-if="city.stores.length > 0">
                <li
                  v-for="store in city.stores"
                  :key="store.id"
                >
                  <router-link
                    class="store"
                    :class="{ 'has-parent': slotProps.item.children.length > 1 }"
                    :to="{ name: store.path, params: store.params }"
                    v-text="store.name"
                  />
                </li>
              </template>
            </li>
          </ul>
        </template>
      </SidebarNavItem>
    </div>
    <div
      v-if="isSortedByState"
      :item="isSortedByState"
    >
      <SidebarNavItem :item="storeLocations">
        <template v-slot:default="slotProps">
          <ul class="links">
            <li
              v-for="state in slotProps.item.children"
              :key="state.name"
              class="cities"
            >
              <router-link
                class="city"
                :class="{ 'display-city': slotProps.item.children.length > 1 }"
                :to="{ name: state.path, hash: state.hash }"
                v-text="state.name"
              />
              <template v-if="state.stores.length > 0">
                <li
                  v-for="store in state.stores"
                  :key="store.id"
                >
                  <router-link
                    class="store"
                    :class="{ 'has-parent': slotProps.item.children.length > 1 }"
                    :to="{ name: store.path, params: store.params }"
                    v-text="store.name"
                  />
                </li>
              </template>
            </li>
          </ul>
        </template>
      </SidebarNavItem>
    </div>
    <SidebarNavItem
      v-for="page in storesAndEventsPages"
      :key="page.id"
      :item="page"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PagesDataTransformer from '@/data/booking-service/PagesDataTransformer.js'
import StoresByCityDataTransformer from '@/data/booking-service/StoresByCityDataTransformer.js'
import StoresByStateDataTransformer from '@/data/booking-service/StoresByStateDataTransformer.js'
import SidebarNavItem from './SidebarNavItem.vue'
import { dynamicLoadStore } from '@/mixins/store-util'
import bookingService from '@/store/modules/booking-service'

export default {
  name: 'StoresAndEventsSidebar',
  components: {
    SidebarNavItem
  },
  mixins: [
    dynamicLoadStore({ bookingService })
  ],
  computed: {
    ...mapGetters('bookingService', ['storesByCity', 'pages', 'beautyClasses', 'storesByState', 'isSortedByState']),
    storeEvents () {
      return {
        name: this.$t('retailStore.events'),
        path: 'discover-event-index',
        gaTrackingClass: 'ga-olr-fs-link',
        children: []
      }
    },
    beautyClass () {
      return {
        name: this.$t('retailStore.classes'),
        path: 'beauty-classes-index',
        gaTrackingClass: 'ga-olr-fs-link',
        children: []
      }
    },
    storeLocations () {
      if (this.isSortedByState) {
        return {
          name: this.$t('retailStore.findStore'),
          path: 'store-location-index',
          gaTrackingClass: 'ga-olr-fs-link',
          children: new StoresByStateDataTransformer(this.storesByState).transformedData
        }
      } else {
        return {
          name: this.$t('retailStore.findStore'),
          path: 'store-location-index',
          gaTrackingClass: 'ga-olr-fs-link',
          children: new StoresByCityDataTransformer(this.storesByCity).transformedData
        }
      }
    },
    storesAndEventsPages () {
      return new PagesDataTransformer(this.pages).transformedData
    }
  }
}
</script>

<style lang='scss' scoped>
@include media-breakpoint-down(md) {
  .sidebar-nav-stores-and-events {
    border-bottom: 2px solid $grey-light;
    margin-bottom: 10px;
  }

  .row {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.cities {
  margin-top: 2px;
}

.city {
  display: none;

  &.display-city {
    display: block;
  }
}

.store {
  &.has-parent {
    padding-left: 26px;
  }
}
</style>
